import { defineComponent as d, createElementBlock as o, openBlock as r, normalizeClass as n, renderSlot as t } from "vue";
import { _ as u } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const a = d({
  name: "vs-card",
  props: {
    paddingValue: {
      type: Number,
      default: 4
    },
    roundedTL: {
      type: Boolean,
      default: !0
    },
    roundedTR: {
      type: Boolean,
      default: !0
    },
    roundedBL: {
      type: Boolean,
      default: !0
    },
    roundedBR: {
      type: Boolean,
      default: !0
    }
  },
  setup() {
    return {};
  }
});
function l(e, p, s, f, i, m) {
  return r(), o("div", {
    class: n(
      `p-${e.paddingValue} w-full shadow-sm border border-opacity-20
      ${e.roundedTL ? "rounded-tl-xl" : ""}
      ${e.roundedTR ? "rounded-tr-xl" : ""}
      ${e.roundedBL ? "rounded-bl-xl" : ""}
      ${e.roundedBR ? "rounded-br-xl" : ""}`
    )
  }, [
    t(e.$slots, "default")
  ], 2);
}
const c = /* @__PURE__ */ u(a, [["render", l]]);
export {
  c as v
};
//# sourceMappingURL=vsCard-CgHEnE92.mjs.map
